import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tRegister System\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* HOISTED */);
const _hoisted_8 = { class: "form-contents" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_12 = {
    name: "system_details",
    class: "clearfix"
};
const _hoisted_13 = { class: "clearfix" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tCompany *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_16 = { class: "invalid-feedback" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tSite *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_19 = { class: "invalid-feedback" };
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_22 = ["disabled"];
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("div", { class: "mt-2" }, "\r\n\t\t\t\t\t\t\t\t\t\t\tYou can enter a descriptive name for this system so that it's easy to find in the future.\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_25 = { class: "float-end float-start-sm" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Generate Registration", -1 /* HOISTED */);
const _hoisted_28 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_30 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Copy to Clipboard", -1 /* HOISTED */);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cloud-download" }, null, -1 /* HOISTED */);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Save to File", -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _directive_validate = _resolveDirective("validate");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.goBack
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _hoisted_15,
                                        _createTextVNode(),
                                        _withDirectives((_openBlock(), _createBlock(_component_multiselect, {
                                            name: "companyId",
                                            modelValue: _ctx.company,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.company) = $event)),
                                            "track-by": "value",
                                            label: "text",
                                            placeholder: _ctx.selectPlaceholder,
                                            options: _ctx.companies,
                                            showLabels: false,
                                            allowEmpty: false,
                                            class: _normalizeClass({ 'is-invalid': _ctx.errors.has('companyId') }),
                                            disabled: _ctx.registered
                                        }, {
                                            noResult: _withCtx(() => [
                                                _createTextVNode("No results found")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "class", "disabled"])), [
                                            [_directive_validate, 'requiredNumericIdentifier', "companyId"]
                                        ]),
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("div", _hoisted_16, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please select a company.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                            [_vShow, _ctx.errors.has('companyId')]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_17, [
                                        _hoisted_18,
                                        _createTextVNode(),
                                        _withDirectives((_openBlock(), _createBlock(_component_multiselect, {
                                            name: "siteId",
                                            modelValue: _ctx.site,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.site) = $event)),
                                            "track-by": "value",
                                            label: "text",
                                            placeholder: _ctx.selectPlaceholder,
                                            options: _ctx.sites,
                                            showLabels: false,
                                            allowEmpty: false,
                                            class: _normalizeClass({ 'is-invalid': _ctx.errors.has('siteId') }),
                                            disabled: _ctx.registered
                                        }, {
                                            noResult: _withCtx(() => [
                                                _createTextVNode("No results found")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "class", "disabled"])), [
                                            [_directive_validate, 'requiredNumericIdentifier', "siteId"]
                                        ]),
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("div", _hoisted_19, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please select a site.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                            [_vShow, _ctx.errors.has('siteId')]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_20, [
                                        _hoisted_21,
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            name: "systemName",
                                            class: "form-control",
                                            placeholder: "New system",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.system.systemName) = $event)),
                                            disabled: _ctx.registered
                                        }, null, 8 /* PROPS */, _hoisted_22), [
                                            [_vModelText, _ctx.system.systemName]
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_23
                                    ]),
                                    _createTextVNode(),
                                    _withDirectives(_createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: _ctx.save
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_26,
                                                    _hoisted_27
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"])
                                        ])
                                    ], 512 /* NEED_PATCH */), [
                                        [_vShow, !_ctx.registered]
                                    ])
                                ]),
                                _createTextVNode(),
                                (_ctx.registered)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                id: "config",
                                                class: "form-control",
                                                rows: "5",
                                                readonly: "",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.registrationResult) = $event))
                                            }, "\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vModelText, _ctx.registrationResult]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_30, [
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: _ctx.copyToClipboard
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_31,
                                                    _hoisted_32
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: _ctx.downloadFile
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_33,
                                                    _hoisted_34
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
